export default __webpack_public_path__ + "static/media/summer_camp_kids.50e25f0b.png";